'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import { Phone, Mail, MapPin, Shield, AlertTriangle, ChevronDown } from 'lucide-react';

const col2Links = [
  { label: 'Être accompagné', href: '/tre-accompagn' },
  { label: 'Aidants', href: '/choisir-mon-parcours' },
  { label: 'Ressources', href: '/ressources' },
  { label: 'Actualités', href: '/actualites' },
  { label: 'Témoignages', href: '/temoignages' },
  { label: "Comité d\'experts", href: '/notre-mission/comite-experts' },
];

const col3Links = [
  { label: 'Faire un don', href: 'https://www.helloasso.com/associations/apte-accompagnement-et-prevention-des-traumatismes-emotionnels/formulaires/1', external: true },
  { label: 'Devenir adhérent', href: 'https://www.helloasso.com/associations/apte-accompagnement-et-prevention-des-traumatismes-emotionnels/adhesions/apte-1', external: true },
  { label: 'Devenir mécène', href: '/#soutenir' },
  { label: 'Construire un partenariat', href: '/#soutenir' },
];

const footerLegal = [
  { label: 'Mentions légales', href: '/mentions-legales' },
  { label: 'Confidentialité', href: '/confidentialite' },
  { label: 'Cookies', href: '/cookies' },
  { label: 'Accessibilité', href: '/accessibilite' },
  { label: 'Aide immédiate', href: '/#aide-immediate' },
];

const socialLinks = [
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/@stefalias4100',
    label: 'Chaîne YouTube APTE (nouvel onglet)',
    svgPath: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100090081587000',
    label: 'Page Facebook APTE (nouvel onglet)',
    svgPath: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/apte_asso/',
    label: 'Compte Instagram APTE (nouvel onglet)',
    svgPath: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
  },
  {
    name: 'LinkedIn',
    href: 'https://t.ly/AH6Sh',
    label: 'Page LinkedIn APTE (nouvel onglet)',
    svgPath: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
];

function TikTokIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z" />
    </svg>
  );
}

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  id: string;
}

function FooterAccordion({ title, children, defaultOpen = false, id }: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const contentId = `footer-accordion-${id}`;
  const buttonId = `footer-btn-${id}`;

  return (
    <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
      <button
        id={buttonId}
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-full text-left transition-all duration-200 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 rounded"
        style={{
          minHeight: '52px',
          padding: '14px 0',
          color: 'rgba(255,255,255,0.75)',
          fontSize: '15px',
          fontWeight: 600,
        }}
        aria-expanded={open}
        aria-controls={contentId}
      >
        {title}
        <ChevronDown
          size={16}
          className={`flex-shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          style={{ color: 'rgba(255,255,255,0.40)' }}
          aria-hidden="true"
        />
      </button>
      <div
        id={contentId}
        role="region"
        aria-labelledby={buttonId}
        style={{
          display: open ? 'block' : 'none',
          paddingBottom: '12px',
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default function PublicFooter() {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="bg-[#071923] text-white" role="contentinfo">
      {/* Compact disclaimer banner */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div
          className="mx-auto px-4 py-3"
          style={{ width: 'min(calc(100% - 28px), 1280px)', marginInline: 'auto' }}
        >
          <div className="flex items-center gap-2.5" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)' }}>
            <Shield size={14} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
            <p>
              APTE n&apos;est pas un service d&apos;urgence.{' '}
              <Link
                href="/#aide-immediate"
                className="underline underline-offset-2 hover:text-white transition-all duration-200"
                style={{ color: 'rgba(255,255,255,0.65)' }}
              >
                Consulter la page Aide immédiate.
              </Link>
            </p>
          </div>
        </div>
      </div>

      {/* ── DESKTOP footer — 4 columns ── */}
      <div
        className="hidden lg:block mx-auto"
        style={{
          width: 'min(calc(100% - 64px), 1280px)',
          marginInline: 'auto',
          paddingTop: '52px',
          paddingBottom: '44px',
        }}
      >
        <div className="grid grid-cols-4 gap-6">

          {/* Col 1 — Identity */}
          <div>
            <div className="mb-4">
              <AppImage
                src="/assets/images/logo_complet_v1-1785763750516.png"
                alt="Logo APTE"
                width={140}
                height={54}
                className="object-contain"
                style={{ objectFit: 'contain' }}
                priority={false}
              />
            </div>
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, marginBottom: '16px' }}>
              APTE informe, prévient, oriente et accompagne les personnels de secours et de sécurité confrontés aux conséquences psychotraumatiques de leurs missions, ainsi que leurs proches.
            </p>
            <div className="flex items-center gap-2 flex-wrap">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex items-center justify-center rounded-lg transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
                  style={{ width: '36px', height: '36px', background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.55)', minWidth: '36px' }}
                >
                  <svg width={18} height={18} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d={s.svgPath} />
                  </svg>
                </a>
              ))}
              <a
                href="https://www.tiktok.com/@association.apte"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Compte TikTok APTE (nouvel onglet)"
                className="flex items-center justify-center rounded-lg transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
                style={{ width: '36px', height: '36px', background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.55)', minWidth: '36px' }}
              >
                <TikTokIcon size={18} />
              </a>
            </div>
          </div>

          {/* Col 2 — Navigation + Soutenir */}
          <div>
            <h3 className="font-semibold uppercase tracking-wider mb-4" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)' }}>
              Accompagnement
            </h3>
            <ul className="space-y-1.5 mb-6">
              {col2Links.map((item) => (
                <li key={item.label}>
                  <Link href={item.href} className="transition-all duration-200 hover:text-white flex items-center min-h-[36px]" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.60)' }}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="font-semibold uppercase tracking-wider mb-4" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)' }}>
              Soutenir APTE
            </h3>
            <ul className="space-y-1.5">
              {col3Links.map((item) => (
                <li key={item.label}>
                  {item.external ? (
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="transition-all duration-200 hover:text-white flex items-center gap-1 min-h-[36px]" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.60)' }}>
                      {item.label}
                      <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.28)' }} aria-hidden="true">↗</span>
                    </a>
                  ) : (
                    <Link href={item.href} className="transition-all duration-200 hover:text-white flex items-center min-h-[36px]" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.60)' }}>
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Contacts */}
          <div>
            <h3 className="font-semibold uppercase tracking-wider mb-4" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)' }}>
              Contacts
            </h3>
            <address className="not-italic space-y-4">
              <div>
                <p className="font-semibold mb-0.5" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.82)' }}>Stéphane Saison</p>
                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.42)', marginBottom: '6px' }}>Président fondateur</p>
                <div className="space-y-1">
                  <a href="tel:+33620122135" className="flex items-center gap-2 hover:text-white transition-all duration-200 min-h-[36px]" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.58)' }}>
                    <Phone size={12} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                    06&nbsp;20&nbsp;12&nbsp;21&nbsp;35
                  </a>
                  <a href="mailto:stephane.saison@asso-apte.fr" className="flex items-center gap-2 hover:text-white transition-all duration-200 min-h-[36px] break-all" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.58)' }}>
                    <Mail size={12} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                    stephane.saison@asso-apte.fr
                  </a>
                </div>
              </div>
              <div>
                <p className="font-semibold mb-0.5" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.82)' }}>Julie Marolles</p>
                <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.42)', marginBottom: '6px' }}>Thérapeute, Secrétaire et Trésorière</p>
                <div className="space-y-1">
                  <a href="tel:+33638490212" className="flex items-center gap-2 hover:text-white transition-all duration-200 min-h-[36px]" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.58)' }}>
                    <Phone size={12} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                    06&nbsp;38&nbsp;49&nbsp;02&nbsp;12
                  </a>
                  <a href="mailto:julie.marolles@asso-apte.fr" className="flex items-center gap-2 hover:text-white transition-all duration-200 min-h-[36px] break-all" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.58)' }}>
                    <Mail size={12} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                    julie.marolles@asso-apte.fr
                  </a>
                </div>
              </div>
            </address>
          </div>

          {/* Col 4 — Address + Aide immédiate */}
          <div>
            <h3 className="font-semibold uppercase tracking-wider mb-4" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.38)' }}>
              Adresse
            </h3>
            <div className="flex items-start gap-2 mb-5" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.58)' }}>
              <MapPin size={13} style={{ color: '#D1A338', flexShrink: 0, marginTop: '2px' }} aria-hidden="true" />
              <address className="not-italic leading-relaxed">
                <p className="font-medium" style={{ color: 'rgba(255,255,255,0.80)' }}>Association APTE</p>
                <p>25 rue de Choisy</p>
                <p>60170 Tracy-le-Mont</p>
                <p>France</p>
              </address>
            </div>
            <div className="rounded-xl p-4" style={{ background: '#FFF4F4', border: '1px solid rgba(180,40,40,0.22)' }}>
              <div className="flex items-start gap-2">
                <AlertTriangle size={14} style={{ color: '#7A1E1E', flexShrink: 0, marginTop: '2px' }} aria-hidden="true" />
                <div>
                  <p className="font-semibold mb-1" style={{ fontSize: '13px', color: '#7A1E1E' }}>Besoin d&apos;une aide immédiate&nbsp;?</p>
                  <p className="leading-relaxed mb-2" style={{ fontSize: '12px', color: '#7A1E1E', opacity: 0.80 }}>
                    APTE n&apos;est pas un service d&apos;urgence. Si vous êtes en danger, contactez les services d&apos;urgence.
                  </p>
                  <Link href="/#aide-immediate" className="inline-flex items-center gap-1 font-semibold underline underline-offset-2 transition-opacity hover:opacity-75" style={{ fontSize: '12px', color: '#7A1E1E' }}>
                    Page Aide immédiate
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.40)' }}>
            <p>Copyright © 2023–{currentYear} APTE. Tous droits réservés.</p>
            <p className="mt-0.5" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.28)' }}>
              Association APTE · SIRET 922 963 608 00018 · RNA W603007709
            </p>
          </div>
          <nav aria-label="Liens légaux">
            <ul className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
              {footerLegal.map((item) => (
                <li key={item.label}>
                  <Link href={item.href} className="hover:text-white transition-all duration-200 min-h-[36px] flex items-center" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.50)' }}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* ── MOBILE footer — accordions ── */}
      <div
        className="lg:hidden"
        style={{
          width: 'min(calc(100% - 28px), 600px)',
          marginInline: 'auto',
          paddingTop: '32px',
          paddingBottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        {/* Logo + description + socials */}
        <div className="mb-6">
          <div className="mb-4">
            <AppImage
              src="/assets/images/logo_complet_v1-1785763750516.png"
              alt="Logo APTE"
              width={130}
              height={50}
              className="object-contain"
              style={{ objectFit: 'contain' }}
              priority={false}
            />
          </div>
          <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, marginBottom: '16px' }}>
            APTE informe, prévient, oriente et accompagne les personnels de secours et de sécurité confrontés aux conséquences psychotraumatiques de leurs missions.
          </p>
          {/* Social icons */}
          <div className="flex items-center gap-2 flex-wrap">
            {socialLinks.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="flex items-center justify-center rounded-lg transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
                style={{ width: '44px', height: '44px', background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.55)' }}
              >
                <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d={s.svgPath} />
                </svg>
              </a>
            ))}
            <a
              href="https://www.tiktok.com/@association.apte"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Compte TikTok APTE (nouvel onglet)"
              className="flex items-center justify-center rounded-lg transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
              style={{ width: '44px', height: '44px', background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.55)' }}
            >
              <TikTokIcon size={20} />
            </a>
          </div>
        </div>

        {/* Quick contacts */}
        <div className="mb-4 flex gap-3">
          <a
            href="tel:+33620122135"
            className="flex-1 flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
            style={{ background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.75)', minHeight: '44px', fontSize: '14px', border: '1px solid rgba(255,255,255,0.10)' }}
          >
            <Phone size={14} aria-hidden="true" />
            Appeler APTE
          </a>
          <a
            href="mailto:stephane.saison@asso-apte.fr"
            className="flex-1 flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
            style={{ background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.75)', minHeight: '44px', fontSize: '14px', border: '1px solid rgba(255,255,255,0.10)' }}
          >
            <Mail size={14} aria-hidden="true" />
            Écrire à APTE
          </a>
        </div>

        {/* Accordions */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <FooterAccordion title="Accompagnement" id="accompagnement">
            <ul className="space-y-1">
              {col2Links.map((item) => (
                <li key={item.label}>
                  <Link href={item.href} className="flex items-center min-h-[44px] transition-all duration-200 hover:text-white" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.60)' }}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </FooterAccordion>

          <FooterAccordion title="Soutenir APTE" id="soutenir">
            <ul className="space-y-1">
              {col3Links.map((item) => (
                <li key={item.label}>
                  {item.external ? (
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-2 min-h-[44px] transition-all duration-200 hover:text-white" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.60)' }}>
                      {item.label}
                      <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.28)' }} aria-hidden="true">↗</span>
                    </a>
                  ) : (
                    <Link href={item.href} className="flex items-center min-h-[44px] transition-all duration-200 hover:text-white" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.60)' }}>
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </FooterAccordion>

          <FooterAccordion title="Contacts et adresse" id="contacts" defaultOpen={false}>
            <address className="not-italic space-y-4">
              <div>
                <p className="font-semibold" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.82)' }}>Stéphane Saison</p>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.42)', marginBottom: '8px' }}>Président fondateur</p>
                <a href="tel:+33620122135" className="flex items-center gap-2 min-h-[44px] hover:text-white transition-all duration-200" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.60)' }}>
                  <Phone size={14} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                  06 20 12 21 35
                </a>
                <a href="mailto:stephane.saison@asso-apte.fr" className="flex items-center gap-2 min-h-[44px] hover:text-white transition-all duration-200 break-all" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.60)' }}>
                  <Mail size={14} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                  stephane.saison@asso-apte.fr
                </a>
              </div>
              <div>
                <p className="font-semibold" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.82)' }}>Julie Marolles</p>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.42)', marginBottom: '8px' }}>Thérapeute, Secrétaire et Trésorière</p>
                <a href="tel:+33638490212" className="flex items-center gap-2 min-h-[44px] hover:text-white transition-all duration-200" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.60)' }}>
                  <Phone size={14} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                  06 38 49 02 12
                </a>
                <a href="mailto:julie.marolles@asso-apte.fr" className="flex items-center gap-2 min-h-[44px] hover:text-white transition-all duration-200 break-all" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.60)' }}>
                  <Mail size={14} style={{ color: '#D1A338', flexShrink: 0 }} aria-hidden="true" />
                  julie.marolles@asso-apte.fr
                </a>
              </div>
              <div className="flex items-start gap-2" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.58)' }}>
                <MapPin size={14} style={{ color: '#D1A338', flexShrink: 0, marginTop: '2px' }} aria-hidden="true" />
                <address className="not-italic leading-relaxed">
                  <p>25 rue de Choisy</p>
                  <p>60170 Tracy-le-Mont, France</p>
                </address>
              </div>
            </address>
          </FooterAccordion>

          <FooterAccordion title="Informations légales" id="legal">
            <ul className="space-y-1">
              {footerLegal.map((item) => (
                <li key={item.label}>
                  <Link href={item.href} className="flex items-center min-h-[44px] transition-all duration-200 hover:text-white" style={{ fontSize: '15px', color: 'rgba(255,255,255,0.60)' }}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </FooterAccordion>
        </div>

        {/* Bottom line */}
        <div className="mt-6 pt-5" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.40)' }}>
            Copyright © 2023–{currentYear} APTE. Tous droits réservés.
          </p>
          <p className="mt-1" style={{ fontSize: '14px', color: 'rgba(255,255,255,0.28)' }}>
            Association APTE · SIRET 922 963 608 00018 · RNA W603007709
          </p>
        </div>
      </div>
    </footer>
  );
}